import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,

  id: null,
  name: null,
  brand: null,
  description: null,
  sex: null,
  img: null,
  media: null,
  category: null,
  rating: null,
  texts: null,
  volumes: [],
  notes: null,
  makeupMedia: null,
  tagTypes: null,
  type: null,
  typeGroup: null,
  retailPrice: null,
  reviewVideo: [],

  labels: [],
  heroImages: [],
  recommendations: [],

  reviewsData: {
    isFetching: false,
    sortBy: 'recent',
    selectedRating: undefined,
    paginationCursor: 0,

    userReview: null,
    count: null,
    rating: {
      average: 0,
      reviewCount: 0,
      reviews: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
    },
    reviews: [],
    expertReview: null,
  },

  meta: {
    title: '',
    description: '',
  },
  pageTitle: null,
  source: null,
  oldPathname: null,

  activeVolumeIndex: 0,

  isVisible: true,
  isGenderVisible: true,
  isSubscribedToStockNotification: false,
  limitedEditionProductsRemainingCount: null,
  isLimitedEdition: false,
  limitedEditionVolumeCustomText: null,

  isLandingVersionEnabled: false,
}

export const reset = () => initialState

export const setFetching = (state, payload) =>
  ({ ...state, isFetching: payload })

export const set = (state, payload) => {
  const keysToKeep = [ 'source', 'isLandingVersionEnabled' ]
  const keep       = object.filterByKey(state, (key) => keysToKeep.indexOf(key) > -1)

  // TODO: why do we need to merge payload with initial state? Shoundn't we merge it with state instead?
  return {
    ...object.mergeDeep(initialState, payload),
    ...keep,
  }
}

export const setRecommendations = (state, payload) =>
  ({ ...state, recommendations: payload })

export const setActiveVolumeIndex = (state, payload /* index */) =>
  ({ ...state, activeVolumeIndex: payload })

export const setReviewsFetching = (state, payload) =>
  (object.setIn(state, [ 'reviewsData', 'isFetching' ], payload))

export const setReviews = (state, payload) =>
  (object.update(state, 'reviewsData', (reviewsData) => ({ ...reviewsData, ...payload, isFetching:false })))

export const setReviewVoteFor = (state, { reviewId, replyId, isUseful }) => {
  const { reviews } = state.reviewsData

  // TODO set expertReviewVoteFor
  const reviewIndex = reviews.findIndex((r) => r.id === reviewId)

  if (reviewIndex === -1) {
    return state
  }

  let path

  if (replyId) {
    const { replies } = reviews[reviewIndex]
    const replyIndex = replies.findIndex((r) => r.id === replyId)
    if (replyIndex === -1) {
      return state
    }

    path = [ 'reviewsData', 'reviews', reviewIndex, 'replies', replyIndex ]
  }
  else {
    path = [ 'reviewsData', 'reviews', reviewIndex ]
  }

  return object.updateIn(state, path, (review) => {
    const prevIsUseful = review.isUseful
    const newReview = { ...review, isUseful }

    if (prevIsUseful !== true && isUseful === true) {
      ++newReview.likeCount
    }
    if (prevIsUseful === true && isUseful !== true) {
      --newReview.likeCount
    }
    if (prevIsUseful !== false && isUseful === false) {
      ++newReview.dislikeCount
    }
    if (prevIsUseful === false && isUseful !== false) {
      --newReview.dislikeCount
    }

    return newReview
  })
}

export const setExpertReviewVoteFor = (state, payload) =>
  object.updateIn(state, [ 'reviewsData', 'expertReview' ], (expertReview) => {
    const prevIsUseful = expertReview.isUseful
    const newReview = { ...expertReview, isUseful: payload }

    if (prevIsUseful !== true && payload === true) {
      ++newReview.likeCount
      ++newReview.upvoteCount
    }
    if (prevIsUseful === true && payload !== true) {
      --newReview.likeCount
      --newReview.upvoteCount
    }
    if (prevIsUseful !== false && payload === false) {
      ++newReview.dislikeCount
      ++newReview.downvoteCount
    }
    if (prevIsUseful === false && payload !== false) {
      --newReview.dislikeCount
      --newReview.downvoteCount
    }

    return newReview
  })

export const setPaginationCursor = (state, payload) =>
  object.setIn(state, [ 'reviewsData', 'paginationCursor' ], payload)

export const setSortBy = (state, payload) =>
  object.setIn(state, [ 'reviewsData', 'sortBy' ], payload)

export const setSelectedRating = (state, payload) =>
  object.setIn(state, [ 'reviewsData', 'selectedRating' ], payload)

export const setIsSubscribedToStockNotification = (state, payload) =>
  ({ ...state, isSubscribedToStockNotification: payload })

export const setIsLandingVersionEnabled = (state, payload) =>
  ({ ...state, isLandingVersionEnabled: payload })

export const setSource = (state, payload) =>
  ({ ...state, source: payload })

export const setOldPathname = (state, payload) =>
  ({ ...state, oldPathname: payload })
